import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import { ChangeStatusFunction } from '../../../../../data/hooks/change-status'
import ChangeStatus from './change-status'
import { StatusEnum } from '../../../../../data/book/data-types'

type ChangeStatusDialogProps = {
    statusId?: StatusEnum
    changeStatus: ChangeStatusFunction
}

const ChangeStatusDialog: React.FunctionComponent<ChangeStatusDialogProps> = ({ statusId, changeStatus }) => {
  return (
    <Container>
      <ChangeStatus changeStatus={changeStatus} statusId={statusId}/>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
	
  display: grid;
	grid-template-columns: auto;
	align-items: center;
  justify-items: center;
  grid-gap: 16px;

	width: 100%;
  max-width: 1024px;

	padding: 24px 16px;

	${up('tablet')} {
		padding: 64px 48px;
    width: 500px;
	}
`

export default ChangeStatusDialog